import { useMemo } from 'react';
import { pick, values } from 'lodash/fp';
import { connect } from 'react-redux';
import algoliasearch from 'algoliasearch/lite';

/**
 * Provides search config and credentials to children of this component
 */
const SearchConfigProvider = ({ loading, query, config, children }) => {
  const indexesList = values(config.indexes);
  const searchClient = useMemo(() => {
    if (config.appId && config.apiKey) {
      return algoliasearch(config.appId, config.apiKey);
    }
    return null;
  }, [config.appId, config.apiKey]);
  return children({
    loading,
    query,
    indexes: config.indexes,
    credentialsProps: {
      searchClient,
      // <InstantSearch> requires at least one indexName to be passed directly
      // even when with multi-index search
      indexName: indexesList[0],
    },
  });
};

const mapStateToProps = state => ({
  loading: state.search.loading,
  config: pick(['apiKey', 'appId', 'indexes'], state.search),
  query: state.search.query,
});

export default connect(mapStateToProps)(SearchConfigProvider);
